import script from "./HeadingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadingPanel.vue?vue&type=script&setup=true&lang=js"

import "./HeadingPanel.vue?vue&type=style&index=0&id=92ac524a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ac524a"]])

export default __exports__